import { showError, createError } from "#app";

export const useErrorHandler = () => {
	const handleApiError = (error: any, context?: string) => {
		const logPrefix = context ? `${context}: ` : "";

		console.error(`${logPrefix}Error loading`, error);
		console.error(`${logPrefix}Error status`, error?.status);

		if (error?.status === 404) {
			console.error(`${logPrefix}Resource not found, showing 404`);
			showError(
				createError({
					statusCode: 404,
					statusMessage: "Resource not found",
				})
			);
		} else {
			console.error(`${logPrefix}An unexpected error occurred`);
			showError(
				createError({
					statusCode: error?.status ?? 500,
					statusMessage: error?.message ?? "Internal Server Error",
				})
			);
		}
	};

	return {
		handleApiError,
	};
};
